import { __awaiter } from "tslib";
import apis from '@/requests';
import moment from 'moment';
export const Options = {
    body: {
        tags: [],
        type: [],
        memo: ['#ms.length|max:50'],
        breed: [],
        farmId: [],
        message: ['#ms.length|max:50'],
        archived: [],
        createdAt: []
    },
    refs: {
        events: '[eventData]',
        market: 'market',
        weather: 'weather',
        revenues: '[revenue]',
        eventMessage: 'eventMessage'
    },
    views: {
        image(self) {
            return `pictures/${self.farmId}-${self.createdAt}.jpg`;
        },
        miniImage(self) {
            return `pictures/${self.farmId}-${self.createdAt}-min.jpg`;
        },
        createdAt(self) {
            return moment(self.createdAt).format('YYYY-MM-DD');
        },
        totalExpenditure(self) {
            let value = 0;
            self.revenues.forEach(e => {
                if (e.expenditure === true) {
                    value += e.value;
                }
            });
            return value;
        },
        totalIncome(self) {
            let value = 0;
            self.revenues.forEach(e => {
                if (e.expenditure === false) {
                    value += e.value;
                }
            });
            return value;
        }
    },
    methods: {
        getEventsDetail(self, type) {
            let events = [];
            for (let i = 0; i < self.eventMessage.items.length; i++) {
                let item = self.eventMessage.items[i];
                events.push({
                    type: type.events.fetch(item.key),
                    event: self.events.fetch(item.key),
                    images: item.images,
                    message: item.text
                });
            }
            return events;
        }
    },
    loaders: {
        fetchToday(self, done, fail, { farmId }) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    let data = yield apis.picture.getToday(farmId);
                    if (data) {
                        self.$init(data);
                    }
                    done(self);
                }
                catch (error) {
                    fail(error);
                }
            });
        },
        createToday(self, done, fail, { farmId, type, breed }) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    let result = yield apis.picture.createToday(farmId, type, breed);
                    done(result);
                }
                catch (error) {
                    fail(error);
                }
            });
        },
        update(self, done, fail) {
            return __awaiter(this, void 0, void 0, function* () {
                if (self.$ready) {
                    try {
                        let params = {
                            tags: self.tags,
                            memo: self.memo,
                            events: self.events.exports(),
                            message: self.message,
                            revenues: self.revenues.exports()
                        };
                        let result = yield apis.picture.update(self.farmId, self.createdAt, params);
                        done(result);
                    }
                    catch (error) {
                        fail(error);
                    }
                }
                else {
                    fail('Picture not ready');
                }
            });
        }
    },
    list: {
        views: {
            days(self) {
                return self.items.map(e => moment(e.createdAt).format('YYYY-MM-DD'));
            },
            totalExpenditure(self) {
                let value = 0;
                self.items.forEach(e => value += e.$v.totalExpenditure);
                return value;
            },
            totalIncome(self) {
                let value = 0;
                self.items.forEach(e => value += e.$v.totalIncome);
                return value;
            },
            totalRain(self) {
                let value = 0;
                self.items.forEach(e => value += e.weather.rain || 0);
                return Number(value.toFixed(2));
            },
            totalSunshine(self) {
                let value = 0;
                self.items.forEach(e => value += e.weather.sunshine || 0);
                return Number(value.toFixed(2));
            }
        },
        loaders: {
            fetchArchived(self, done, fail, { farmId, startTime, finishTime }) {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        let result = yield apis.picture.getArchives(farmId, startTime, finishTime);
                        self.batchWrite(result.items);
                        done(self);
                    }
                    catch (error) {
                        fail(error);
                    }
                });
            }
        }
    }
};
